import {
  CheckCircledIcon,
  CrossCircledIcon,
  UpdateIcon,
} from '@radix-ui/react-icons';
import { Box, Text } from '@radix-ui/themes';
import { PitchListHelper } from 'classes/helpers/pitch-list.helper';
import { CustomIcon } from 'components/common/custom-icon';
import { CustomIconPath } from 'enums/custom.enums';
import { TrainedStatus } from 'lib_ts/enums/pitch-list.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IAggregateMachineShotsEntry } from 'lib_ts/interfaces/training/i-machine-shot';

const TrainedStatusIcon = (props: {
  mode: TrainedStatus;
  className?: string;
}) => {
  switch (props.mode) {
    case TrainedStatus.Precision: {
      return (
        <Text color={RADIX.COLOR.SUCCESS} className={props.className}>
          <CustomIcon icon={CustomIconPath.CheckCircledFilled} />
        </Text>
      );
    }

    case TrainedStatus.Trained: {
      return (
        <Text color={RADIX.COLOR.SUCCESS} className={props.className}>
          <CheckCircledIcon />
        </Text>
      );
    }

    case TrainedStatus.Untrained:
    default: {
      return (
        <Text color={RADIX.COLOR.NEUTRAL} className={props.className}>
          <CrossCircledIcon />
        </Text>
      );
    }
  }
};

export const CommonTrainingStatusIcon = (props: {
  aggShots: IAggregateMachineShotsEntry | undefined;
  threshold: number;
  precision: boolean;
  // if false, then an update icon will be shown if the pitch can be refreshed
  autoRefresh: boolean;
  canRefresh: boolean;
}) => {
  const status = PitchListHelper.getTrainedStatus({
    aggShots: props.aggShots,
    precision: props.precision,
    threshold: props.threshold,
  });

  const showUpdateIcon = !props.autoRefresh && props.canRefresh;

  return (
    <Box
      data-testid="ShotSummary"
      data-total={props.aggShots?.total}
      data-qt={props.aggShots?.qt}
      data-qt-complete={props.aggShots?.qt_complete}
    >
      <UpdateIcon className={!showUpdateIcon ? 'hidden' : ''} />
      <TrainedStatusIcon
        mode={status}
        className={showUpdateIcon ? 'hidden' : ''}
      />
    </Box>
  );
};
